
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 1042","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 56.24 72.109"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Rectangle 441","fill":"#5fd95f","d":"M0 0h56.24v72.109H0z"}})])]),_c('path',{attrs:{"data-name":"Path 7122","d":"M0 36.501v35.6h56.24v-35.6l-8.54-6v3.335l5.827 4.072v31.486H2.715V37.906l15.478-11.04v-3.335z","fill":"#5fd95f"}}),_c('g',{attrs:{"data-name":"Group 1039"}},[_c('g',{attrs:{"data-name":"Group 1038","clip-path":"url(#a)","fill":"#5fd95f"}},[_c('path',{attrs:{"data-name":"Path 7123","d":"M36.45 48.811a8.168 8.168 0 11-12.328-7.033 7.929 7.929 0 012.493-.961V19.534h3.329v21.283a7.959 7.959 0 012.5.961 8.208 8.208 0 012.636 2.509 8.094 8.094 0 011.369 4.524"}}),_c('path',{attrs:{"data-name":"Path 7124","d":"M35.157 37.113V6.875a6.875 6.875 0 00-13.751 0v30.238a13.577 13.577 0 1013.751 0m-6.875 22.565a10.868 10.868 0 01-4.16-20.9V6.875a4.16 4.16 0 018.32 0v31.906a10.863 10.863 0 01-4.16 20.9"}}),_c('path',{attrs:{"data-name":"Rectangle 436","d":"M37.86 31.242h7.758v2.592H37.86z"}}),_c('path',{attrs:{"data-name":"Rectangle 437","d":"M37.86 7.941h7.758v2.592H37.86z"}}),_c('path',{attrs:{"data-name":"Rectangle 438","d":"M37.86 19.573h7.758v2.592H37.86z"}}),_c('path',{attrs:{"data-name":"Rectangle 439","d":"M37.86 25.35h4.98v2.592h-4.98z"}}),_c('path',{attrs:{"data-name":"Rectangle 440","d":"M37.86 13.796h4.98v2.592h-4.98z"}})])])])
          )
        }
      }
    